import React from 'react'

import './ButtonPlaceholder.scss'

export default function ButtonPlaceholder() {
  return (
    <div className="button-placeholder" />
  )
}
